// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__54YLB","skeleton-animation":"styles_skeleton-animation__LLsBx","container":"styles_container__FcGSz"};